import {
  faBars,
  faBrowser,
  faBullhorn,
  faCalendarAlt,
  faCalendarCheck,
  faCashRegister,
  faClock,
  faEnvelope,
  faMoneyBillWave,
  faRocketLaunch,
  faShoppingCart,
  faStore,
  faUser,
  faUserCircle,
  faUserHelmetSafety,
  faUsers,
  faUserTimes,
} from '@fortawesome/pro-light-svg-icons'

import { ISettingModal } from './ISettingModal'

const settingsPath: string = `/settings`

export const settingOptions: ISettingModal[] = [
    {
        name: 'Account',
        icon: faUserCircle,
        color: '#c191f6',
        isBeta: false,
        url: `${settingsPath}/account`,
        modulePermissions: [],
        userPermissions: ['settings.account.manage'],
        isLimitedToPartner: false,
    },
    {
        name: 'Users',
        icon: faUser,
        color: '#ff982d',
        isBeta: false,
        url: `${settingsPath}/user`,
        modulePermissions: [],
        userPermissions: ['hr.users.manage'],
        isLimitedToPartner: false,
    },
    {
        name: 'Customer',
        icon: faUsers,
        color: '#69d321',
        isBeta: false,
        url: `${settingsPath}/customer`,
        modulePermissions: [],
        userPermissions: [],
        isLimitedToPartner: false,
    },
    {
        name: 'Calendar',
        icon: faCalendarAlt,
        color: '#ffab0f',
        isBeta: false,
        url: `${settingsPath}/calendar`,
        modulePermissions: ['calendar'],
        userPermissions: [],
        isLimitedToPartner: false,
    },
    {
        name: 'Absence',
        icon: faUserTimes,
        color: '#ff6d54',
        isBeta: false,
        url: `/hr/absences`,
        modulePermissions: ['calendar'],
        userPermissions: ['hr.absences.manage'],
        isLimitedToPartner: false,
    },
    {
        name: 'Activities',
        icon: faCalendarCheck,
        color: '#ff5475',
        isBeta: false,
        url: `${settingsPath}/activities`,
        modulePermissions: ['calendar', 'register'],
        userPermissions: ['settings.activities.manage'],
        isLimitedToPartner: false,
    },
    {
        name: 'Menus',
        icon: faBars,
        color: '#ff73b1',
        isBeta: false,
        url: `${settingsPath}/menus`,
        modulePermissions: ['calendar', 'register'],
        userPermissions: ['settings.activities.manage'],
        isLimitedToPartner: false,
    },
    {
        name: 'Register',
        icon: faCashRegister,
        color: '#8262d8',
        isBeta: false,
        url: `${settingsPath}/register`,
        modulePermissions: ['register'],
        userPermissions: ['settings.register.manage'],
        isLimitedToPartner: false,
    },
    {
        name: 'Punch clock',
        icon: faClock,
        color: '#f8549c',
        isBeta: false,
        url: `${settingsPath}/punchclock`,
        modulePermissions: ['punchclock'],
        userPermissions: ['hr.time.manage'],
        isLimitedToPartner: false,
    },
    {
        name: 'Website',
        icon: faBrowser,
        color: '#f8549c',
        isBeta: false,
        url: `/website/update`,
        modulePermissions: ['website'],
        userPermissions: [],
        isLimitedToPartner: false,
    },
    {
        name: 'Webshop',
        icon: faShoppingCart,
        color: '#c191f6',
        isBeta: true,
        url: `${settingsPath}/webshop`,
        modulePermissions: ['shopify'],
        userPermissions: ['settings.webshop.manage'],
        isLimitedToPartner: false,
    },
    {
        name: 'Online payments',
        icon: faMoneyBillWave,
        color: '#d24444',
        isBeta: true,
        url: `${settingsPath}/online-payment`,
        modulePermissions: ['online_payments'],
        userPermissions: ['settings.online_payment.manage'],
        isLimitedToPartner: false,
    },
    {
        name: 'Shop',
        icon: faStore,
        color: '#ff7f5f',
        isBeta: false,
        url: `${settingsPath}/shop`,
        modulePermissions: [],
        userPermissions: ['settings.shop.manage'],
        isLimitedToPartner: false,
    },
    {
        name: 'Communication',
        icon: faEnvelope,
        color: '#24a7f3',
        isBeta: false,
        url: `${settingsPath}/communication`,
        modulePermissions: [],
        userPermissions: [],
        isLimitedToPartner: false,
    },
    {
        name: 'Marketing',
        icon: faBullhorn,
        color: '#24a7f3',
        isBeta: false,
        url: `${settingsPath}/marketing`,
        modulePermissions: ['marketing'],
        userPermissions: [],
        isLimitedToPartner: false,
    },
    {
        name: 'App Store',
        icon: faRocketLaunch,
        color: '#8262d8',
        isBeta: false,
        url: `${settingsPath}/appstore`,
        modulePermissions: ['register'],
        userPermissions: [],
        isLimitedToPartner: false,
    },
    {
        name: 'Partner',
        icon: faUserHelmetSafety,
        color: '#8262d8',
        isBeta: false,
        url: `${settingsPath}/partner`,
        modulePermissions: [],
        userPermissions: [],
        isLimitedToPartner: true,
    },
]
